import { render, staticRenderFns } from "./breadcrumbNav.vue?vue&type=template&id=2857ab32"
import script from "./breadcrumbNav.vue?vue&type=script&lang=js"
export * from "./breadcrumbNav.vue?vue&type=script&lang=js"
import style0 from "./breadcrumbNav.vue?vue&type=style&index=0&id=2857ab32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports